import React, { useState } from 'react';
import { Search, Filter, Bell } from 'lucide-react';
import './Topbar.css';

interface TopbarProps {
  title: string;
  searchValue?: string;
  onSearch?: (value: string) => void;
  badge?: string;
}

export default function Topbar({ title, searchValue = '', onSearch, badge }: TopbarProps) {
  const [search, setSearch] = useState(searchValue);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    onSearch?.(e.target.value);
  };

  return (
    <div className="topbar">
      <div className="topbar-header">
        <span className="topbar-title">{title}</span>
        {badge && <span className="topbar-badge">{badge}</span>}
      </div>
      {onSearch && (
        <div className="topbar-search">
          <Search size={18} className="search-icon" />
          <input
            type="text"
            placeholder="Buscar proposições, temas, autores…"
            value={search}
            onChange={handleSearchChange}
            className="search-input"
          />
        </div>
      )}
      <div className="topbar-actions">
        <button className="chip" title="Filtros">
          <Filter size={16} />
          <span>Filtros</span>
        </button>
        <button className="chip" title="Alerta">
          <Bell size={16} />
          <span>Alerta</span>
        </button>
      </div>
    </div>
  );
}
